<div class="mini-spinner-box">
	<mat-spinner></mat-spinner>
</div>